import { render, staticRenderFns } from "./OneRelatedTopicWidget.vue?vue&type=template&id=79046932&scoped=true&"
import script from "./OneRelatedTopicWidget.vue?vue&type=script&lang=js&"
export * from "./OneRelatedTopicWidget.vue?vue&type=script&lang=js&"
import style0 from "./OneRelatedTopicWidget.vue?vue&type=style&index=0&id=79046932&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79046932",
  null
  
)

export default component.exports